import { useEffect, useState } from "react";
import { listBlockedNumbers, addBlockedNumber, removeBlockedNumber, BlockedNumber } from "../../lib/whatsappMessages";
import { useAuth } from "../../contexts/AuthContext";

export function WhatsAppBlockedView() {
  const { user } = useAuth();
  const adminUserId: string | null = user?.id ?? null;
  const [rows, setRows] = useState<BlockedNumber[]>([]);
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    listBlockedNumbers()
      .then(setRows)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    setError(null);
    try {
      if (!/^\+[1-9]\d{6,14}$/.test(phone)) {
        setError("Voer een geldig E.164-nummer in (bijv. +31612345678).");
        return;
      }
      await addBlockedNumber(phone, reason, adminUserId);
      setPhone("");
      setReason("");
      load();
    } catch (e) {
      setError((e as Error).message);
    }
  };

  return (
    <div className="space-y-6">
        {/* Add form */}
        <div className="bg-white rounded-lg shadow p-4">
          <h2 className="text-sm font-medium text-gray-700 mb-3">Nummer blokkeren</h2>
          <div className="flex flex-wrap gap-4 items-end">
            <label className="text-sm font-medium text-gray-700">
              Nummer (E.164)
              <input
                className="block mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#231F20] focus:border-transparent"
                placeholder="+31612345678"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </label>
            <label className="text-sm font-medium text-gray-700 flex-1">
              Reden
              <input
                className="block mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#231F20] focus:border-transparent"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </label>
            <button
              className="px-4 py-2 rounded-lg transition-colors bg-[#231F20] text-white hover:bg-[#3a3536]"
              onClick={add}
            >
              Blokkeren
            </button>
          </div>
          {error && <p className="text-red-600 mt-3 text-sm">{error}</p>}
        </div>

        {/* Table */}
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="w-12 h-12 border-4 border-[#231F20] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : rows.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Geen geblokkeerde nummers</h3>
            <p className="text-gray-600">Er zijn nog geen nummers geblokkeerd.</p>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nummer</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Reden</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Geblokkeerd sinds</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acties</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {rows.map((r) => (
                  <tr key={r.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{r.phone}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.reason ?? ""}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                      {new Date(r.blocked_at).toLocaleDateString("nl-NL")}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <button
                        className="px-3 py-1.5 rounded-lg text-sm transition-colors bg-white text-red-600 border border-red-300 hover:bg-red-50"
                        onClick={async () => { await removeBlockedNumber(r.id); load(); }}
                      >
                        Deblokkeren
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
